<template>
  <div 
    v-if="isLoading" 
    class="d-flex justify-content-center"
  >
    <f-loading-spinner />
  </div>
  <form 
    v-else 
    id="check-form" 
    :action="`/staffsafe/admin/checks/${checkId}`"
    method="post"
  >
    <input 
      type="hidden" 
      name="_method"
      value="put"
    >
    <input 
      type="hidden" 
      name="authenticity_token" 
      :value="csrfToken"
    >
    <form-input 
      name="check[name]"
      label="Check Name"
      :model-value="checkName"
      required 
    />
    <div class="mt-2">
      <select-input
        :key="checkGroup"
        name="check[check_group_id]"
        label="Check Group"
        :model-value="checkGroup"
        :options="checkGroups"
      />
    </div>
    <div class="mt-2">
      <select-input
        :key="checkGroup"
        name="check[field_type]"
        label="Check Type"
        :model-value="checkType"
        :options="checkTypes"
        @change:model-value="changeType"
      />
    </div>
    <div 
      v-if="isCheckWarningVisible" 
      class="check-type-warning" 
      data-testid="check-type-warning"
    >
      <p>Changing the type of a check will remove any associated role requirements, and the check values will attempt to be converted to the new type. However, this may result in data loss. <strong>Please note that this action cannot be undone.</strong></p>
    </div>
    <div 
      v-if="checkRoles" 
      class="mt-2 field" 
      data-testid="check-roles-section"
    >
      <span class="field__label">This Check Applies to These Roles</span>
      <div class="roles">
        <span 
          v-for="role in checkRoles" 
          :key="role" 
          class="mr-1 d-inline-block"
        >
          {{ role }}
        </span>
      </div>
    </div>
  </form>
</template>

<script>
import { createFetch } from "@vueuse/core";
import { ref, watchEffect } from "vue";
import { CHECK_TYPES } from "../constants.js";
export default {
  name: "CheckForm",
  props: {
    checkId:{
      type: Number,
      required: true
    },
    csrfToken:{
      type: String,
      required: true
    }
  },

  setup(props) {
    const checkName = ref("");
    const checkType = ref("");
    const checkTypes = CHECK_TYPES;
    const checkGroup = ref("");
    const checkGroups = ref([]);
    const checkRoles = ref([]);
    const isLoading = ref(true);
    const isCheckWarningVisible = ref(false);

    const useCheckFetch = createFetch({
      baseUrl: "/staffsafe/admin/checks/",
      method: "GET",
      immediate: true,
    });

    const { data, isFetching } = useCheckFetch(props.checkId);

    watchEffect(() => {
      if (data.value) {
        const parsedData = JSON.parse(data.value);

        checkName.value = parsedData.check.name;
        checkType.value = parsedData.check.field_type;
        checkGroup.value = parsedData.current_check_group.id;
        checkGroups.value = parsedData.check_groups;

        if(parsedData.roles && parsedData.roles.length > 0){
          checkRoles.value = parsedData.roles;
        }else{
          checkRoles.value = false;
        }        
      }
        
      isLoading.value = isFetching.value;
    });

    const changeType = (val)=>{
      isCheckWarningVisible.value = checkType.value !== val;
    };

    return { checkName, checkType, checkTypes, checkGroup, checkGroups, checkRoles, isLoading, changeType, isCheckWarningVisible};
  }
};
</script>

<style lang="scss" scoped>

  :deep(input:disabled){
    text-transform: capitalize;
  }
  .roles{
    span:after{
      content: ",";
    }

    span:last-of-type:after{
      content: "";
    }
  }
  
  .check-type-warning{
    padding: 4px 8px;
    background-color: #e12336;
    color: #fff;
    border-radius: 6px;
  }
</style>
